var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 144,
    viewBox: "0 0 157 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157 78H79V91H157V78Z",
    fill: "#06B3DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157 104H79V118H157V104Z",
    fill: "#06B3DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 144L39 78L78 144H0Z",
    fill: "#F57A3E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3333 26.0034H52.6667V0H79V26.0034V78H39.1119H26.3333H0V51.9966H26.3333V26.0034Z",
    fill: "#06B3DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M157 131H79V144H157V131Z",
    fill: "#06B3DB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157 33.8695V32.1305C157 14.3913 142.004 0 123.5 0C104.996 0 90 14.3813 90 32.1305V66H123.5C142.004 66 157 51.6187 157 33.8695Z",
    fill: "#F57A3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorLogo);
export default __webpack_public_path__ + "static/media/error-logo.1feca28aa73c5e637be6aef14daa40e2.svg";
export { ForwardRef as ReactComponent };